import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import readXlsxFile from 'read-excel-file';
import CircularProgress from 'material-ui/CircularProgress';
import urlBase from '../../../url-base';
import axios from 'axios';
import {Colors, Styles} from '../../../../src/styles/theme';

const MAPA_PARENTESCO = {
  "1": "Titular",
  "3": "Cônjuge",
  "4": "Filho",
  "6": "Enteado",
  "8": "Pai/Mãe",
  "10": "Agregados/Outros"
};

class InclusaoAssociado extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usersTableExt: [],
      fileName: 'Nenhum arquivo escolhido',
      totalErros: 0,
      loading: false,
      empresaDados: null,
      loadingEmpresa: false,
      errorEmpresa: null,
      codigoInput: '',
      resultadosInclusao: [],  
      codigoVendedorInput: '',
      vendedorDados: null,
      loadingVendedor: false,
      errorVendedor: null,          
    };

    this.handleCodigoChange = this.handleCodigoChange.bind(this);
    this.buscarEmpresa = this.buscarEmpresa.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
  }
  buscarVendedor() {
    const { codigoVendedorInput } = this.state;
    if (!codigoVendedorInput) return alert("Informe o código do vendedor");

    this.setState({ loadingVendedor: true, vendedorDados: null, errorVendedor: null });

    const filter = JSON.stringify({
      where: { codeS4: codigoVendedorInput },
      include: "user"
    });

    axios.get(`${urlBase.loopBack}Salesmans?filter=${filter}`)
      .then(res => {
        if (res.data && res.data.length > 0) {
          this.setState({ 
            vendedorDados: res.data[0], 
            loadingVendedor: false 
          });
        } else {
          throw new Error('Vendedor não encontrado');
        }
      })
      .catch(err => {
        err;
        this.setState({ 
          errorVendedor: "Vendedor não localizado no sistema. ", 
          loadingVendedor: false 
        });
      });
  }
  handleCodigoChange(e) {
    this.setState({ codigoInput: e.target.value, errorEmpresa: null });
  }

  calcularMesPrimeiroPagamento(diaCorte, dataReferencia = new Date()) {
    const mesAtual = dataReferencia.getMonth();
    const anoAtual = dataReferencia.getFullYear();
    let mesPagamento = mesAtual;
    let anoPagamento = anoAtual;
    if (diaCorte >= 10) {
      mesPagamento++;
      if (mesPagamento > 11) { mesPagamento = 0; anoPagamento++; }
    }
    const mesFormatado = String(mesPagamento + 1).padStart(2, '0');
    return `${anoPagamento}${mesFormatado}`;
  }

  calcularIdade(dataNascimento) {
    const info = this.validarEConverterData(dataNascimento);

    if (!info.valida) return null;

    const hoje = new Date();
    const nascimento = new Date(info.paraAPI);

    let idade = hoje.getFullYear() - nascimento.getFullYear();

    const mesAtual = hoje.getMonth();
    const diaAtual = hoje.getDate();

    if (
      mesAtual < nascimento.getMonth() ||
      (mesAtual === nascimento.getMonth() &&
        diaAtual < nascimento.getDate())
    ) {
      idade--;
    }

    return idade;
  }
  buscarEmpresa() {
    const { codigoInput } = this.state;
    if (!codigoInput) return alert("Informe o código da empresa");

   // this.setState({ loadingEmpresa: true, empresaDados: null, errorEmpresa: null });

    this.setState({ 
        loadingEmpresa: true, 
        empresaDados: null, 
        errorEmpresa: null,
        // RESETAR ESTES CAMPOS:
        usersTableExt: [], 
        fileName: 'Nenhum arquivo escolhido',
        totalErros: 0,
        resultadosInclusao: [] 
    })    
    axios.post(urlBase.loopBack + 'APIS4s/BuscarEmpresa', { codigo: codigoInput })
      .then(res => {
        const lista = res.data;
        if (lista && lista.length > 0) {
          this.setState({ empresaDados: lista[0], loadingEmpresa: false });
        } else {
          throw new Error('Empresa não encontrada');
        }
      })
      .catch(err => {
        this.setState({ errorEmpresa: err.message, loadingEmpresa: false });
      });
  }
  /*
  validarEConverterData(valor) {
    if (!valor) return { exibicao: "-", paraAPI: null, valida: false };
    let dia, mes, ano;
    if (valor instanceof Date) {
      dia = valor.getDate(); mes = valor.getMonth() + 1; ano = valor.getFullYear();
    } else {
      const str = String(valor).trim();
      const partes = str.split(/[-/]/);
      if (partes.length === 3) {
        if (partes[0].length <= 2) { dia = parseInt(partes[0], 10); mes = parseInt(partes[1], 10); ano = parseInt(partes[2], 10); }
        else { ano = parseInt(partes[0], 10); mes = parseInt(partes[1], 10); dia = parseInt(partes[2], 10); }
      } else return { exibicao: String(valor), paraAPI: null, valida: false };
    }
    const dataTeste = new Date(ano, mes - 1, dia);
    const dataValida = dataTeste.getFullYear() === ano && (dataTeste.getMonth() + 1) === mes && dataTeste.getDate() === dia && ano > 1900;
    if (!dataValida) return { exibicao: String(valor), paraAPI: null, valida: false };
    const dStr = String(dia).padStart(2, '0');
    const mStr = String(mes).padStart(2, '0');
    return { exibicao: `${dStr}/${mStr}/${ano}`, paraAPI: `${ano}-${mStr}-${dStr}`, valida: true };
  }
  */
 /**
  * Código de conversão de data
  * @param {*} valor 
  * @returns 
  */
  validarEConverterData(valor) {
    if (!valor) return { exibicao: "-", paraAPI: null, valida: false };
    let dia, mes, ano;
    
    if (valor instanceof Date) {
      // UTILIZA MÉTODOS UTC PARA EVITAR O DESLOCAMENTO DE DIA ENTRE WINDOWS E LINUX/DOCKER
      dia = valor.getUTCDate(); 
      mes = valor.getUTCMonth() + 1; 
      ano = valor.getUTCFullYear();
    } else {
      const str = String(valor).trim();
      const partes = str.split(/[-/]/);
      if (partes.length === 3) {
        if (partes[0].length <= 2) { 
          dia = parseInt(partes[0], 10); 
          mes = parseInt(partes[1], 10); 
          ano = parseInt(partes[2], 10); 
        } else { 
          ano = parseInt(partes[0], 10); 
          mes = parseInt(partes[1], 10); 
          dia = parseInt(partes[2], 10); 
        }
      } else {
        return { exibicao: String(valor), paraAPI: null, valida: false };
      }
    }

    // Validação usando Date.UTC para isolar de fusos horários locais do servidor
    const dataTeste = new Date(Date.UTC(ano, mes - 1, dia));
    const dataValida = 
      dataTeste.getUTCFullYear() === ano && 
      (dataTeste.getUTCMonth() + 1) === mes && 
      dataTeste.getUTCDate() === dia && 
      ano > 1900;

    if (!dataValida) return { exibicao: String(valor), paraAPI: null, valida: false };
    
    const dStr = String(dia).padStart(2, '0');
    const mStr = String(mes).padStart(2, '0');
    
    return { 
      exibicao: `${dStr}/${mStr}/${ano}`, 
      paraAPI: `${ano}-${mStr}-${dStr}`, 
      valida: true 
    };
  } 
  validarCPF(cpf) {
    if (!cpf) return false;
    const limpo = String(cpf).replace(/\D/g, '');
    if (limpo.length !== 11 || /^(\d)\1{10}$/.test(limpo)) return false;
    let soma = 0, resto;
    for (let i = 1; i <= 9; i++) soma += parseInt(limpo.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11; if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(limpo.substring(9, 10))) return false;
    soma = 0;
    for (let i = 1; i <= 10; i++) soma += parseInt(limpo.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11; if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(limpo.substring(10, 11));
  }

  validarEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).toLowerCase()); }
  validarCelular(cel) { return (String(cel).replace(/\D/g, '').length === 11 || String(cel).replace(/\D/g, '').length === 10) ; }

  handleFileUpload(event) {
    const file = event.target.files[0];
    if (!file) return;
    
    const { empresaDados } = this.state; // Pegamos os dados da empresa carregada
    this.setState({ loading: true, fileName: file.name, usersTableExt: [] });

    setTimeout(() => {
      readXlsxFile(file).then((rows) => {
        let errosEncontrados = 0;
        const colunas = ["TITULAR", "DEPENDENTE", "PARENTESCO", "CPF", "CNS", "DATA DE NASCIMENTO", "TIPO DE PLANO", "NOME DA MÃE", "SEXO", "RG", "ORG. EXPEDIDOR", "CELULAR", "E-MAIL", "CÓDIGO DO PLANO"];

        rows.slice(3).forEach((row) => {
          colunas.forEach((nome, idx) => {
            const val = row[idx];
            
            // Validações existentes...
            if (nome === "DATA DE NASCIMENTO" && !this.validarEConverterData(val).valida) errosEncontrados++;
            //if (nome === "CPF" && !this.validarCPF(val)) errosEncontrados++;
            if (nome === "CPF") {
              const cpfVal = String(val || "").trim();
              // Se estiver vazio OU for inválido, conta como erro
              if (!cpfVal || !this.validarCPF(cpfVal)) {
                errosEncontrados++;
              }
            }            
            if (nome === "E-MAIL" && val && !this.validarEmail(val)) errosEncontrados++;
            if (nome === "CELULAR" && val && !this.validarCelular(val)) errosEncontrados++;

            // NOVA VALIDAÇÃO: CÓDIGO DO PLANO (Coluna 13)
            if (nome === "CÓDIGO DO PLANO") {
              const codPlano = String(val || "").trim();
              // Verifica se o código existe na lista PrecoPlano da empresa
              const planoExiste = empresaDados.PrecoPlano.some(p => String(p.Plano).trim() === codPlano);
              if (!planoExiste) {
                errosEncontrados++;
              }
            }
            // verificação da idade do dependente
         
          });
        const titular = String(row[0] || "").trim();
        const dependente = String(row[1] || "").trim();
        const celular = String(row[11] || "").trim();

        const idade = this.calcularIdade(row[5]);

        // TITULAR => obrigatório
        if (titular) {
          if (!celular || !this.validarCelular(celular)) {
            errosEncontrados++;
          }
        }

        // DEPENDENTE MAIOR DE 18 => obrigatório
        if (dependente && idade !== null && idade >= 18) {
          if (!celular || !this.validarCelular(celular)) {
            errosEncontrados++;
          }
        }

        // DEPENDENTE MENOR DE 18 => opcional
        if (
          dependente &&
          idade !== null &&
          idade < 18 &&
          celular &&
          !this.validarCelular(celular)
        ) {
          errosEncontrados++;
        }             
        });

        this.setState({ usersTableExt: rows, totalErros: errosEncontrados, loading: false });
      }).catch(() => { 
        this.setState({ loading: false }); 
        alert("Erro ao processar arquivo."); 
      });
    }, 500);

    event.target.value = null;
  }
  // Método isolado para gerenciar os envios de WhatsApp
  enviarNotificacoesWhats(resultados, dadosPlanilha) {
    const sucessos = resultados.filter(item => item.codigo === 1);
    
    if (sucessos.length === 0) return Promise.resolve();

    const enviosWhats = sucessos.map(item => {
      // Buscamos a linha na planilha que corresponde ao CPF do sucesso
      const linhaOriginal = dadosPlanilha.find(row => 
        String(row[3] || "").replace(/\D/g, '') === item.cpf
      );

      if (linhaOriginal && linhaOriginal[11]) {
        const dadosWhats = {
          numero: String(linhaOriginal[11]).replace(/\D/g, ''),
          nome: linhaOriginal[0] || item.nome
        };
        // Retornamos a promessa do axios
        return axios.post(urlBase.loopBack + 'Sales/enviarWhatsapp', dadosWhats)
          .catch(e => {
            console.error(`Erro ao enviar WhatsApp para ${dadosWhats.nome}`, e);
            return null; // Evita que um erro de envio trave o Promise.all
          });
      }
      return Promise.resolve();
    });

    return Promise.all(enviosWhats);
  }
  enviarDadosParaS4() {
    const funcionarioCadastro =  localStorage.getItem('dental_codeS4')
    const { usersTableExt, empresaDados } = this.state;
    const dadosPlanilha = usersTableExt.slice(3); // Pula os cabeçalhos
    this.setState({ loading: true });

    const listSendS4 = [];
    let contratoAtual = null;

    dadosPlanilha.forEach((row) => {
      const nomeTitular = row[0] ? String(row[0]).trim() : null;
      const nomeDependente = row[1] ? String(row[1]).trim() : null;
      const parentesco = row[2];
      //const email = row[12];
      const email = row[12] || "";
      // Se a linha estiver totalmente vazia (nem titular nem dependente), ignora
      if (!nomeTitular && !nomeDependente) return;

      const dataNasc = this.validarEConverterData(row[5]).paraAPI;
      const cpfLimpo = String(row[3] || "").replace(/\D/g, '');
      const celularLimpo = String(row[11] || "").replace(/\D/g, '');
      const mesPagamento = this.calcularMesPrimeiroPagamento(empresaDados.Corte);
      const sexoNum = (row[8] === "M" || row[8] === "Masculino") ? 1 : 0;
      // --- BUSCA DINÂMICA DO VALOR DO PLANO ---
      const codigoPlanoPlanilha = String(row[13] || "").trim();
      let valorEncontrado = 0;

      if (empresaDados.PrecoPlano && codigoPlanoPlanilha) {
        // Procura o plano correspondente no objeto da empresa
        const planoInfo = empresaDados.PrecoPlano.find(p => String(p.Plano) === codigoPlanoPlanilha);
        
        if (planoInfo) {
          // Se for Titular (tipo 1), usa ValorTitular. Se for Dependente (tipo 2), usa ValorDependente.
          valorEncontrado = nomeTitular ? planoInfo.ValorTitular : planoInfo.ValorDependente;
        }
      }
      // 1. LÓGICA DE TITULAR (Nova raiz no JSON)
      if (nomeTitular) {
          let celularTitular = celularLimpo;
          let emailTitular = email;

          let contatoResponsavelFinanceiro = [];
          if (celularTitular) {
            contatoResponsavelFinanceiro.push({ tipo: 8, dado: celularTitular });
          }
          if (emailTitular) {
            contatoResponsavelFinanceiro.push({ tipo: 50, dado: emailTitular });
          }

          contratoAtual = {
            token: "",
            dados: {
              empresa: empresaDados.Id,
              parceiro: { codigo: this.state.vendedorDados.codeS4, maxMensalidadeId: 1, tipoCobranca: 1 },
              responsavelFinanceiro: {
                codigoContrato: empresaDados.Id,
                nome: nomeTitular,
                dataNascimento: dataNasc,
                cpf: cpfLimpo,
                identidadeNumero: row[9] || "",
                identidadeOrgaoExpeditor: row[10],
                sexo: sexoNum,
                endereco: { 
                  cep: empresaDados.Cep, tipoLogradouro: empresaDados.IdTipoLogradouro, logradouro: empresaDados.Logradouro, 
                  numero: empresaDados.Numero, complemento: empresaDados.Complemento, bairro: empresaDados.Bairro, 
                  municipio: empresaDados.Municipio, uf: empresaDados.Uf 
                },
                // Atribuição direta da propriedade contendo o array de contatos:
                contatoResponsavelFinanceiro: contatoResponsavelFinanceiro 
              },
              dependente: [
                {
                  tipo: 1, // Titular
                  nome: nomeTitular,
                  dataNascimento: dataNasc,
                  cpf: cpfLimpo,
                  sexo: sexoNum,
                  plano: parseInt(codigoPlanoPlanilha),
                  planoValor: valorEncontrado,
                  nomeMae: row[7] || "",
                  idExtendo: -1,
                  funcionarioCadastro: funcionarioCadastro,
                  MMYYYY1Pagamento: mesPagamento,
                  cns: String(row[4] || "").replace(/\D/g, '')
                }
              ]
            }
          };

          // Removida a linha: contratoAtual.dados.responsavelFinanceiro.push(...)

          listSendS4.push(contratoAtual);
      } 
      // 2. LÓGICA DE DEPENDENTE (Adiciona ao array do último titular encontrado)
      else if (nomeDependente && contratoAtual) {
        
        let celularDependente = celularLimpo;
        let emailDependente = email;

        // Monta o array de contatos apenas com os valores que realmente existem
        let contatoDependente = [];

        if (celularDependente) {
          contatoDependente.push({ tipo: 8, dado: celularDependente });
        }

        if (emailDependente) {
          contatoDependente.push({ tipo: 50, dado: emailDependente });
        }

        // Cria o objeto base do dependente
        let dadosDependente = {
          tipo: parentesco,
          nome: nomeDependente,
          dataNascimento: dataNasc,
          cpf: cpfLimpo,
          sexo: sexoNum,
          plano: parseInt(codigoPlanoPlanilha),
          planoValor: valorEncontrado,
          nomeMae: row[7] || "",
          idExtendo: -1,
          funcionarioCadastro: funcionarioCadastro,
          MMYYYY1Pagamento: mesPagamento,
          cns: String(row[4] || "").replace(/\D/g, '')
        };

        // Inclui a propriedade contatoDependente apenas se houver ao menos um contato inserido
        if (contatoDependente.length > 0) {
          dadosDependente.contatoDependente = contatoDependente;
        }

        contratoAtual.dados.dependente.push(dadosDependente);          
      }
   
    });
    console.log(listSendS4) // apagar

    // Envio final
    this.setState({ loading: true, resultadosInclusao: [] });

    axios.post(urlBase.loopBack + 'APIS4s/NovoAssociadoPJ', listSendS4)
    .then((res) => {
      this.setState({ resultadosInclusao: res.data });

      // Passamos o res.data (que contém os códigos e mensagens de retorno)
      // e o usersTableExt (que contém os números de telefone)
      this.enviarNotificacoesWhats(res.data, this.state.usersTableExt)
        .then(() => {
          this.setState({ loading: false });
          
          const totalSucessos = res.data.filter(r => r.codigo === 1).length;
          const totalFalhas = res.data.length - totalSucessos;
          
          alert(`Inclusão Concluída!\n\nSucessos: ${totalSucessos}\nFalhas: ${totalFalhas}\nNotificações enviadas para os casos de sucesso.`);
        });
    })
    .catch(err => {
      err
      this.setState({ loading: false });
      alert("Erro na comunicação com o servidor de inclusão. " );
    }); 


  }
  render() {
    const { usersTableExt, loading, fileName, totalErros, loadingEmpresa, empresaDados, errorEmpresa, codigoInput } = this.state;
    const colunasTab = ["TITULAR", "DEPENDENTE", "PARENTESCO", "CPF", "CNS", "DATA DE NASCIMENTO", "TIPO DE PLANO", "NOME DA MÃE", "SEXO", "RG", "ORG. EXPEDIDOR", "CELULAR", "E-MAIL", "CÓDIGO DO PLANO"];

    const labelStyle = Styles.label;
    const valueStyle = Styles.value;

    // Lógica de Situação do Vendedor
    let statusColor = Colors.textMuted;
    let statusText = "Desconhecido";
    let statusIcon = "❓";

    if (this.state.vendedorDados && this.state.vendedorDados.user) {
      const isActive = this.state.vendedorDados.user.active;
      statusColor = isActive ? Colors.success : Colors.danger;
      statusText = isActive ? "Ativo" : "Inativo";
      statusIcon = isActive ? "✅" : "❌";
    }

    return (
      <div style={{ padding: '20px' }}>
        <p className="title_form" style={{ marginBottom: 35 }}>INCLUSÃO DE ASSOCIADOS</p>

        <Container>
          {/* BUSCA EMPRESA */}
          <Row style={{ marginBottom: 20 }}>
            <Col md={12}>
              <div style={{ padding: '20px', backgroundColor: Colors.white, border: '1px solid #ddd', borderRadius: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px' }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: '12px', fontWeight: 'bold' }}>CÓDIGO DA EMPRESA</label>
                    <input type="text" className="form-control" value={codigoInput} onChange={this.handleCodigoChange} />
                  </div>
                  <button className="btn btn-info" onClick={this.buscarEmpresa} disabled={loadingEmpresa}>
                    {loadingEmpresa ? 'Buscando...' : 'Consultar Empresa'}
                  </button>
                </div>

                {empresaDados && (
                  <div style={{ borderTop: '1px solid #eee', paddingTop: '15px', marginTop: '15px' }}>
                    <Row>
                      <Col md={4}><small style={labelStyle}>Razão Social</small><p style={valueStyle}>{empresaDados.RazaoSocial}</p></Col>
                      <Col md={4}><small style={labelStyle}>Nome Fantasia</small><p style={valueStyle}>{empresaDados.NomeFantazia}</p></Col>
                      <Col md={4}><small style={labelStyle}>CNPJ</small><p style={valueStyle}>{empresaDados.CNPJ}</p></Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                      <Col md={3}><small style={labelStyle}>Corte</small><p style={valueStyle}>{empresaDados.Corte}º dia</p></Col>
                      <Col md={3}>
                        <small style={labelStyle}>1º Pagamento</small>
                        <p style={valueStyle}>{this.calcularMesPrimeiroPagamento(empresaDados.Corte).replace(/(\d{4})(\d{2})/, '$2/$1')}</p>
                      </Col>
                      <Col md={3}>
                        <small style={labelStyle}>Situação</small><br/>
                        <span style={{ padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 'bold', backgroundColor: empresaDados.NomeSituacao === 'ATIVO' ? '#e8f5e9' : '#ffebee', color: empresaDados.NomeSituacao === 'ATIVO' ? '#2e7d32' : '#c62828' }}>
                          {empresaDados.NomeSituacao}
                        </span>
                      </Col>
                    </Row>

                    <div style={{ marginTop: 20 }}>
                      <p style={{ fontSize: '12px', fontWeight: 'bold', color: '#555' }}>PLANOS HABILITADOS</p>
                      <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                          <TableRow style={{ backgroundColor: Colors.primary }}> 
                            <TableHeaderColumn style={{ color: Colors.white, fontWeight: 'bold' }}>CÓD. PLANO</TableHeaderColumn>
                            <TableHeaderColumn style={{ color: Colors.white, fontWeight: 'bold' }}>TITULAR</TableHeaderColumn>
                            <TableHeaderColumn style={{ color: Colors.white, fontWeight: 'bold' }}>DEP.</TableHeaderColumn>
                            <TableHeaderColumn style={{ color: Colors.white, fontWeight: 'bold' }}>AGREGADO</TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                          {empresaDados.PrecoPlano && empresaDados.PrecoPlano.map((p, i) => (
                            <TableRow key={i}>
                              <TableRowColumn>{p.Plano}</TableRowColumn>
                              <TableRowColumn>{p.ValorTitular.toLocaleString('pt-br',{style:'currency',currency:'BRL'})}</TableRowColumn>
                              <TableRowColumn>{p.ValorDependente.toLocaleString('pt-br',{style:'currency',currency:'BRL'})}</TableRowColumn>
                              <TableRowColumn>{p.ValorAgregado.toLocaleString('pt-br',{style:'currency',currency:'BRL'})}</TableRowColumn>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                )}
                {errorEmpresa && <div style={{ color: Colors.danger, marginTop: 10 }}>⚠️ {errorEmpresa}</div>}
              </div>
            </Col>
          </Row>
          {/* BUSCA VENDEDOR (PARCEIRO) */}
          {empresaDados && (
          <Col md={12} style={{ marginTop: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px' }}>
              <div style={{ flex: 1 }}>
                <label style={Styles.label}>CÓDIGO DO VENDEDOR / PARCEIRO</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={this.state.codigoVendedorInput} 
                  onChange={(e) => this.setState({ codigoVendedorInput: e.target.value })} 
                />
              </div>
              <button className="btn btn-info" onClick={() => this.buscarVendedor()} disabled={this.state.loadingVendedor}>
                {this.state.loadingVendedor ? 'Validando...' : 'Consultar Vendedor'}
              </button>
            </div>
            
          {this.state.vendedorDados && (
            <div style={{ 
              marginTop: '10px', 
              padding: '10px', 
              borderRadius: '4px', 
              backgroundColor: '#f9f9f9', 
              border: `1px solid ${Colors.borderLight}` 
            }}>
              <span style={{ fontSize: '13px', fontWeight: 'bold', color: Colors.textDark }}>
                {statusIcon} Vendedor: {this.state.vendedorDados.user.name} (Cod: {this.state.vendedorDados.codeS4})
              </span>
              <span style={{ 
                marginLeft: '15px', 
                fontSize: '12px', 
                fontWeight: 'bold', 
                color: statusColor,
                textTransform: 'uppercase'
              }}>
                • Situação: {statusText}
              </span>
            </div>
          )}
            {this.state.errorVendedor && <div style={{ color: Colors.danger, fontSize: '12px' }}>{this.state.errorVendedor}</div>}
          </Col>  
          )}        
          {/* ÁREA CONDICIONAL ABAIXO */}
          {empresaDados && this.state.vendedorDados && this.state.vendedorDados.user.active  ? (
            <div key="upload-area">
              <Row style={{ marginBottom: 20, marginTop: 20 }}>
                <Col md={12}>
                  <div style={{ backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '5px', border: '1px dashed #ccc', display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <label htmlFor="input-file" className={`btn btn-primary ${loading ? 'disabled' : ''}`} style={{ marginBottom: 0, cursor: 'pointer' }}>
                      {loading ? 'Processando...' : 'Selecionar Planilha'}
                    </label>
                    <input id="input-file" type="file" accept=".xlsx, .xls" onChange={this.handleFileUpload} style={{ display: 'none' }} disabled={loading} />
                    <span style={{ fontSize: '14px', color: '#555' }}>{fileName}</span>
                    {usersTableExt.length > 0 && !loading && (
                      <div style={{ marginLeft: 'auto', padding: '5px 15px', borderRadius: '20px', backgroundColor: totalErros > 0 ? '#ffeded' : '#e8f5e9', color: totalErros > 0 ? '#d32f2f' : '#2e7d32', fontWeight: 'bold' }}>
                        {totalErros > 0 ? `⚠️ ${totalErros} erros encontrados` : "✅ Dados válidos"}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>

              {loading && (
                <div style={{ textAlign: 'center', marginTop: 50 }}>
                  <CircularProgress size={60} thickness={5} />
                  <p style={{ marginTop: '10px', color: '#666' }}>Validando planilha...</p>
                </div>
              )}

              {!loading && usersTableExt.length > 0 && (
                <div style={{ width: '100%', overflowX: 'auto', border: '1px solid #ddd', borderRadius: '4px', marginTop: '20px' }}>
                  <div style={{ minWidth: '2800px' }}>
                   
                    <Table selectable={false}>
                      <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow style={{ backgroundColor: Colors.primary }}>
                          <TableHeaderColumn style={{ color: '#fff', width: '60px', textAlign: 'center' }}>#</TableHeaderColumn>
                          {colunasTab.map(h => <TableHeaderColumn key={h} style={{ color: '#fff', fontWeight: 'bold' }}>{h}</TableHeaderColumn>)}
                        </TableRow>
                      </TableHeader>
                      <TableBody displayRowCheckbox={false}>
                        {usersTableExt.slice(3).map((row, rIdx) => (
                          <TableRow key={rIdx}>
                            <TableRowColumn style={{ textAlign: 'center', width: '70px', fontWeight: 'bold', backgroundColor: '#f1f1f1' }}>{rIdx + 1}</TableRowColumn>
                            {colunasTab.map((h, cIdx) => {
                              const val = row[cIdx];
                              let display = val || "-";
                              let erro = false;
                              if (h === "PARENTESCO") {
                                const codParentesco = String(val || "").trim();
                                // Se o código existir no nosso mapa, exibe "Código - Descrição"
                                if (MAPA_PARENTESCO[codParentesco]) {
                                  display = `${codParentesco} - ${MAPA_PARENTESCO[codParentesco]}`;
                                } else {
                                  // Se for um código que não está no mapa, marca como erro
                                  erro = true;
                                  display = val ? `${val} (Inválido)` : "Vazio";
                                }
                              }                              
                              if (h === "DATA DE NASCIMENTO") { 
                                const info = this.validarEConverterData(val); 
                                display = info.exibicao; 
                                if (!info.valida && val) erro = true; 
                              }
                              else if (h === "CPF") {
                                const cpfLimpo = String(val || "").trim();
                                
                                if (!cpfLimpo) {
                                  // Caso esteja vazio
                                  erro = true;
                                  display = "Não informado"; // Mantém o traço que você desejava
                                } else if (!this.validarCPF(cpfLimpo)) {
                                  // Caso tenha algo, mas seja inválido
                                  erro = true;
                                  display = cpfLimpo;
                                }
                              }

                              else if (h === "E-MAIL" && val && !this.validarEmail(val)) erro = true;
                              
                              //else if (h === "CELULAR" && val && !this.validarCelular(val)) erro = true;
                              //
                              else if (h === "CELULAR") {
                                const titular = String(row[0] || "").trim();
                                const dependente = String(row[1] || "").trim();
                                const idade = this.calcularIdade(row[5]);

                                // Titular
                                if (titular) {
                                  if (!val) {
                                    erro = true;
                                    display = "Celular obrigatório";
                                  } else if (!this.validarCelular(val)) {
                                    erro = true;
                                  }
                                }

                                // Dependente maior de idade
                                else if (dependente && idade !== null && idade >= 18) {
                                  if (!val) {
                                    erro = true;
                                    display = "Celular obrigatório para dependentes maior que 18";
                                  } else if (!this.validarCelular(val)) {
                                    erro = true;
                                  }
                                }

                                // Dependente menor de idade
                                else if (
                                  dependente &&
                                  idade !== null &&
                                  idade < 18 &&
                                  val &&
                                  !this.validarCelular(val)
                                ) {
                                  erro = true;
                                }
                              }                              
                              //
                              if (h === "CÓDIGO DO PLANO") {
                                  const codPlano = String(val || "").trim();
                                  const planoExiste = empresaDados.PrecoPlano.some(p => String(p.Plano).trim() === codPlano);
                                  if (!planoExiste) {
                                    erro = true;
                                    display = "Código inválido";
                                  }
                              }   
                              // 1. Buscamos se existe um resultado de processamento para o CPF desta linha
                                const cpfLinha = String(row[3] || "").replace(/\D/g, '');
                                const resultado = this.state.resultadosInclusao.find(r => r.cpf === cpfLinha);

                                return (
                                  <TableRowColumn key={cIdx} style={{ color: erro ? Colors.danger : '#444' }}>
                                    {display}
                                    
                                    {/* 2. Se for a coluna de nome ou CPF, e tivermos resultado, mostra o selo de status */}
                                    {h === "TITULAR" && resultado && (
                                      <div style={{ 
                                        fontSize: '10px', 
                                        marginTop: '4px',
                                        color: resultado.codigo === 1 ? Colors.success : Colors.danger,
                                        fontWeight: 'bold'
                                      }}>
                                        {resultado.codigo === 1 ? '✓ SUCESSO' : `✕ ERRO: ${resultado.mensagem}`}
                                      </div>
                                    )}
                                  </TableRowColumn>
                                );                                                         

                            })}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  
                  </div>
                  
                </div>
                
              )}
              
              {/* BOTÃO DE AÇÃO FINAL - Só aparece se houver dados na planilha */}
              {usersTableExt.length > 3 && (
                <div style={{ marginTop: '20px', textAlign: 'right' }}>
                  <button 
                    className="btn btn-success btn-lg" 
                    onClick={() => this.enviarDadosParaS4()}
                    disabled={totalErros > 0 || loading}
                  >
                    {loading ? 'Processando...' : `Finalizar Inclusão de ${usersTableExt.length - 3} Associados`}
                  </button>
                  
                  {totalErros > 0 && (
                    <p style={{ color: Colors.danger, fontSize: '12px', marginTop: '5px' }}>
                      Corrija os erros na planilha para habilitar o envio.
                    </p>
                  )}
                </div>
              )} 

              {/* RESULTADO DO PROCESSAMENTO */}
              {this.state.resultadosInclusao.length > 0 && (
                <div style={{ 
                  padding: '20px', 
                  backgroundColor: '#fff', 
                  marginBottom: '20px', 
                  borderLeft: `5px solid ${Colors.success}`,
                  boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                  borderRadius: '4px'
                }}>
                  <h4 style={{ margin: '0 0 10px 0', color: Colors.primary, display: 'flex', alignItems: 'center' }}>
                    <i className="fa fa-check-circle" style={{ marginRight: '10px', color: Colors.success }}></i>
                    Processamento Concluído
                  </h4>
                  
                  <div style={{ display: 'flex', gap: '20px', fontSize: '15px' }}>
                    <span>Total: <strong>{this.state.resultadosInclusao.length}</strong></span>
                    
                    <span style={{ color: Colors.success }}>
                      <i className="fa fa-user-plus"></i> Sucessos: <strong>{this.state.resultadosInclusao.filter(r => r.codigo === 1).length}</strong>
                    </span>
                    
                    <span style={{ color: Colors.danger }}>
                      <i className="fa fa-exclamation-triangle"></i> Erros: <strong>{this.state.resultadosInclusao.filter(r => r.codigo !== 1).length}</strong>
                    </span>

                    {/* Nova informação do WhatsApp */}
                    <span style={{ color: Colors.secondary }}>
                      <i className="fab fa-whatsapp" style={{ color: Colors.success, marginRight: '5px' }}></i> Notificações: <strong>{this.state.totalWhats || 0}</strong>
                    </span>
                  </div>
                </div>
              )}                           
            </div>
          ) : (
            <Row>
              <Col md={12}>
                <div style={{ textAlign: 'center', padding: '40px', color: '#999', backgroundColor: '#fcfcfc', border: '1px solid #eee', borderRadius: '8px' }}>
                  <p>Por favor, consulte uma empresa e o vendedor para liberar o upload da planilha.</p>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    );
  }
}

export default InclusaoAssociado;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/RegisterCompany/InclusaoAssociado.js
 **/